import React from 'react';
import {Modal} from 'react-bootstrap';
import {
	ComponentUtils,
	DetailActions,
	SwEmbeddedDetail,
	SwForm,
	UniversalCodebookSelection
} from 'simplifyworks-core-ui';
import i18n from 'i18next';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {getElementAfter} from '../../utils';

const DeclineOrganOfferModal = (props) => {
	const otherReasonSelected = props.declineOrganOfferFormData?.reason?.code === 'X';

	return (
		<>
			<Modal
				show={props.show}
				onHide={() => props.close()}
				size={'xl'}
			>
				<Modal.Header closeButton>
					<Modal.Title style={{width: 'auto'}}>
						{i18n.t('foedus-decline-organ-offer')}
					</Modal.Title>
				</Modal.Header>

				<Modal.Body>
					<SwEmbeddedDetail
						name={'decline-organ-offer'}
						rest='/api/foedus/organ-offer/decline'
						restId={'new'}
						tabName={''}
						createButtonLabelKey={'foedus-decline-organ-offer'}
						newCallback={(actionResult, id, errorResponse) => {
							if (!errorResponse) {
								props.close();
								window.location.reload();
							}
						}}
					>
						<SwForm
							name={'decline-organ-offer'}
							rest={''}
							labelKey='foedus-decline-organ-offer'
							initialValue={{
								parentEntryId: props?.entryId
							}}
							valueChanged={(data, property, value, callback) => {
								callback(data);
							}}
						>
							<SwForm.Section>
								<SwForm.EntitySelect
									size={12}
									property='reason'
									rest='/api/ood/codebooks'
									name='reason'
									validations='required'
									labelKey='foedus-organ-offer-decline-reason'
									pageSize={25}
									fixedFilter={{
										codebookType: 'Ood_decline_offer_reasons'
									}}
									render={UniversalCodebookSelection.renderExtendedText}
									searchProperties={['name', 'code']}
									defaultOrdering={[{property: 'rank', order: 'asc'}]}
									writingEnabled
								/>
								<SwForm.String
									size={12}
									property='note'
									labelKey='foedus-organ-offer-decline-note'
									hidden={!otherReasonSelected}
									validations={otherReasonSelected ? 'required' : ''}
									type='area'
								/>
							</SwForm.Section>
						</SwForm>
					</SwEmbeddedDetail>
				</Modal.Body>
			</Modal>
		</>

	);
};

const mapDispatchToProps = (dispatch) => ({
	actions: {
		detail: bindActionCreators(DetailActions, dispatch)
	}
});

const mapStateToProps = (state, ownProps) => {
	const declineOrganOfferFormData = ComponentUtils.getFormData(state, '/api/foedus/organ-offer/decline/new', 'DEFAULT');
	const pathSegments = state?.router?.location?.pathname?.split('/') || [];

	return {
		declineOrganOfferFormData,
		entryId: getElementAfter(pathSegments, 'entries')
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(DeclineOrganOfferModal);
